import { Button, Icon, Title } from 'ui'
import classes from '~/styles/error.module.scss'

import { Center, Container, Grid, Image, Space } from '@mantine/core'
import { useNavigate } from '@remix-run/react'

import { ErrorProps } from './DevelopmentEnvComponent'

interface ErrorComponentProps {
  messageLine1?: string
  messageLine2?: string
  messageDetails?: string
  buttonText: string
  redirectURL: string
}

export const DefaultError = (errorComponentProps: ErrorComponentProps) => {
  const navigate = useNavigate()
  const redirectToPortal = () => {
    const pageName = location?.pathname.split('/')[1]
    navigate(pageName, { replace: false })
    location?.reload()
  }
  return (
    <>
      <Container size="lg" py={50}>
        <Center>
          <Container size="lg" className="alignCenter" py={50}>
            <Grid>
              <Grid.Col span={{ sm: 12, md: 12 }}>
                <Space h={40} />
                <Title order={1} fontWeight="700" variant="yellow">
                  Oh no!
                </Title>
                <Space h={20} />
                <Title order={2} fontWeight="400" variant="white">
                  {errorComponentProps.messageLine1}
                  <br />
                  {errorComponentProps.messageLine2}
                </Title>
                <Space h={40} />
                <Grid className="alignCenter">
                  <Grid.Col span={{ sm: 0, md: 2 }} mt={5} className="alignCenter"></Grid.Col>
                  <Grid.Col span={{ sm: 12, md: 8 }} mt={5} className="alignCenter">
                    <Title order={3} fontWeight="400" variant="white">
                      {errorComponentProps.messageDetails}
                    </Title>
                  </Grid.Col>
                  <Grid.Col span={{ sm: 0, md: 2 }} mt={5} className="alignCenter"></Grid.Col>
                </Grid>

                <Grid className="alignCenter">
                  <Grid.Col span={{ sm: 12, md: 12 }} mt={5}>
                    <Space h={30} />
                    <Button
                      variant="filled"
                      type="submit"
                      onClick={redirectToPortal}
                      className={classes.btnStyle}
                      uppercase={true}
                    >
                      {errorComponentProps.buttonText}
                    </Button>
                  </Grid.Col>
                </Grid>
              </Grid.Col>
            </Grid>
          </Container>
        </Center>
        <Image
          src={'/images/oops.jpeg'}
          classNames={{
            root: classes.imageRoot,
            image: classes.bgImgae,
          }}
        />
      </Container>
      <div></div>
      <div className="svgContainer">
        <Icon name="welcomeWave" />
      </div>
    </>
  )
}

export const DefaultErrorTemplate = ({ error }: ErrorProps) => {
  const messageLine =
    error?.status === 500 ? 'Seems like something went wrong' : "We're having some"

  return (
    <DefaultError
      messageLine1={messageLine}
      messageLine2="technical difficulties."
      buttonText="GO TO MPOWER PORTAL"
      messageDetails="Check back with us later while we figure out what went wrong."
      redirectURL="https://www.mpowerfinancing.com/"
    />
  )
}
